import axios from "axios";

const instance = axios.create({
  baseURL: '//api.iranamlaak.net/',
  headers: {
    "x-app-type": `webapp`
  }
  //   headers: {
  // //  Authorization: `<Your Auth Token>`,
  //     Content-Type: "application/json",
  //     timeout : 1000,
  //   }, 
  //   // .. other options
});

export default instance;
